import { Button, Tooltip } from "@xola/ui-kit";
import React, { useState } from "react";
import { CatalogItem, Experience } from "types";
import { useInvalidate } from "../../hooks/useInvalidation";
import { CreatePurchaseStep, useCreatePurchaseStore } from "../../stores/createPurchaseStore";
import { JoinWaitlistModal } from "../Event/JoinWaitlistModal";
import { useResource } from "@/hooks/useResource";

const JoinWaitlistButton = () => {
    const invalidate = useInvalidate();
    const item = useCreatePurchaseStore((state) => state.getActiveItem());
    const { timeslot } = item;
    const timezone = useCreatePurchaseStore((state) => state.purchase.items[0]?.arrivalTimezoneName);
    const activeItemIndex = useCreatePurchaseStore((state) => state.activeItemIndex);
    const updateQuantity = useCreatePurchaseStore((state) => state.actions.updateQuantity);

    const { data: product, isLoading } = useResource<Experience>(["products", item.product.id]);
    const { outingMax = Number.MAX_VALUE } = product?.group ?? {};

    const [showWaitlistModal, setShowWaitlistModal] = useState<boolean>(false);
    const setEventId = useCreatePurchaseStore((state) => state.actions.setEventId);

    const totalDemographics = item.quantity;
    const error = totalDemographics > outingMax ? `Quantity cannot exceed ${outingMax}` : null;

    const toggleWaitlistModal = () => {
        setShowWaitlistModal(!showWaitlistModal);
    };

    const handleWaitlistSuccess = () => {
        setEventId(timeslot!.event?.id);
        invalidate("timeslots");
        useCreatePurchaseStore.setState({ step: CreatePurchaseStep.WAITLIST_SUCCESS });
        toggleWaitlistModal();
    };

    const handleWaitlistQuantityChange = (catalogItem: CatalogItem, quantity: number) => {
        if (catalogItem.template?.id) {
            updateQuantity(activeItemIndex, catalogItem.template.id, quantity);
        }
    };

    return (
        <>
            <Tooltip content={error} disabled={!error}>
                <Button disabled={error ?? isLoading} onClick={toggleWaitlistModal}>
                    Join Waitlist
                </Button>
            </Tooltip>

            {timeslot && (
                <JoinWaitlistModal
                    isOpen={showWaitlistModal}
                    timeslot={timeslot}
                    initialLineItems={[...item.demographicLineItems, ...(item.equipmentLineItems ?? [])]}
                    timezone={timezone}
                    onClose={toggleWaitlistModal}
                    onSuccess={handleWaitlistSuccess}
                    onQuantityChange={handleWaitlistQuantityChange}
                />
            )}
        </>
    );
};

export default JoinWaitlistButton;
